import { configureStore } from '@reduxjs/toolkit';
import rootSlice from './slices/rootSlice';
import { useDispatch, useSelector } from 'react-redux';
import chatSlice from './slices/chatSlice.js';
import { chatWsMiddleware } from './chatWsMiddleware.js';

const store = configureStore({
  reducer: {
    root: rootSlice,
    chat: chatSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      chatWsMiddleware
    ),
});

export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

export default store;
